var ua = navigator.userAgent;
var m = ua.match(/(chrome|firefox)\/?\s*(\d+)/i);

export default {
  name   : m && m[1],
  version: m && m[2],
};
